import { useAuthMutation } from './auth'
import { ApiAgentRequest, request } from '../utils/request'
import { useQueryClient } from '@tanstack/react-query'

type DeleteLanguageProficiencyByIdParams = {
  studentId: string
  languageProficiencyId: string
}

export function useDeleteLanguageProficiency() {
  const queryClient = useQueryClient()
  
  const { isPending, mutate, mutateAsync } = useAuthMutation(
    async (params: DeleteLanguageProficiencyByIdParams) => {
      const url = `/students/${params.studentId}/language-proficiencies/${params.languageProficiencyId}`

      return request(
          new ApiAgentRequest(url, {
            method: 'DELETE',
          }),
          {
            isExpectedResponse: (res: unknown): res is any => true,
          },
        )
    },
    {
      onSuccess: (data, variables) => {
        // Invalidate language proficiency queries to refetch the data
        queryClient.invalidateQueries({
          queryKey: ['language-proficiency', variables.studentId]
        })
      }
    }
  )

  return {
    isDeletingLanguageProficiency: isPending,
    deleteLanguageProficiency: mutate,
    deleteLanguageProficiencyAsync: mutateAsync,
  }
}